import { Box, Flex } from "@chakra-ui/react";
import { chakra } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { ClickableOverlay } from "../ClickableOverlay";

export const AnimatedGifs = () => {
  const gifs = [
    { fileName: "Bed", altText: "Safe, and protected by source" },
    {
      fileName: "Touched_grass",
      altText: "Grieving you, it's like you're closer than ever before",
    },
    { fileName: "sad-doodles", altText: "Doodles recieves terrible news" },
    { fileName: "sad-holiday", altText: "Cat boy spends Thanksgiving alone" },
    { fileName: "Bunnyspin2", altText: "Spinning around, weeeeeee" },
  ];

  const Video = chakra("video");
  const refs = useRef<(HTMLVideoElement | null)[]>([]);

  // Play/pause when element enters viewport (perfect for mobile)
  useEffect(() => {
    refs.current.forEach((video) => {
      if (!video) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        },
        { threshold: 0.5 }
      );

      observer.observe(video);
    });
  }, []);

  return (
    <Flex flexWrap="wrap" justifyContent="center" gap={10} p={5} width="100%">
      {gifs.map((gif, index) => (
        <ClickableOverlay key={gif.fileName} label={gif.altText}>
          <Video
            ref={(el) => (refs.current[index] = el)}
            src={`/gifs/${gif.fileName}.mp4`}
            muted
            loop
            playsInline
            autoPlay // mobile autoplay allowed because muted
            // Desktop hover play
            onMouseEnter={() => refs.current[index]?.play()}
            onMouseLeave={() => {
              const v = refs.current[index];
              if (!v) return;
              v.pause();
              v.currentTime = 0;
            }}
            style={{
              cursor: "pointer",
              maxHeight: "70vh",
              width: "100%", // prevents overflow on mobile
              height: "auto",
              borderRadius: "25px",
            }}
          />
        </ClickableOverlay>
      ))}
    </Flex>
  );
};
